export const DASHBOARD_SSE_EVENTS = {
    SERVER_DATE: "serverDate",
    ATTENDANCE_SUBTITLES: "attendanceCardsSubtitles",
    GARRISON_SUBTITLES: "garrisonCardSubtitles",
    TASK_SUBTITLES: "taskCardSubtitles",
    ATTENDANCE_CARD: "attendanceCard",
    GARRISON_CARD: "garrisonCard",
    TASK_CARD: "taskCard",
};

export const normalizeSseArray = value => Array.isArray(value) ? value : [];

export const normalizeSseObject = value => {
    if (!value || typeof value !== "object" || Array.isArray(value)) return {};
    return value;
};
